<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent fullscreen>
      <v-btn slot="activator" flat>
        <span class="mr-2">New Game</span>
        <v-icon>add</v-icon>
        <!-- <v-icon>add_circle</v-icon> -->
      </v-btn>
      <v-card>
        <v-card-title class="headline">New Game</v-card-title>
        <v-card-text>
          <div v-if="startnewgame">
            <v-flex xs12 sm6 d-flex>
              <v-select
                v-model="selectedGameType"
                :items="gametype"
                label="Game Type"
                outline
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 d-flex>
              <v-select
                v-model="selectedNumPlayers"
                :items="number_of_players"
                label="# of Players"
                outline
              ></v-select>
            </v-flex>
            <v-btn color="error" @click="dialog = false">Cancel</v-btn>
            <v-btn color="success" @click="startNewGame">Start New Game</v-btn>
          </div>
          <p v-if="!startnewgame">Are you sure you want to clear the score and start a new game?</p>
        </v-card-text>
        <v-card-actions v-if="!startnewgame">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="dialog = false">No</v-btn>
          <v-btn color="green darken-1" flat @click="setupNewGame">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  data: () => ({
    dialog: false,
    startnewgame: false,
    selectedGameType: 'standard',
    selectedNumPlayers: 2,
    number_of_players: [
      { text: 'Two', value: 2 },
      { text: 'Three', value: 3 },
      { text: 'Four', value: 4 },
      { text: 'Five', value: 5 },
      { text: 'Six', value: 6 }
    ],
    gametype: [
      { text: 'Standard', value: 'standard' }
    ]
  }),
  methods: {
    ...mapActions([
      'setPlayers',
      'setGameNumbers'
    ]),
    startNewGame () {
      localStorage.clear()
      this.$store.state.game.game_over = false
      this.$store.state.game.mode = this.selectedGameType
      this.$store.state.game.numplayers = this.selectedNumPlayers
      this.$store.dispatch('setGameNumbers')
      this.$store.dispatch('setPlayers')
      this.dialog = false
      this.vueInsomnia().on()
    },
    setPlayers () {
      this.$store.dispatch('setPlayers')
      this.dialog = false
    },
    setupNewGame () {
      this.startnewgame = true
    }
  }
}
</script>
